import React, {useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';

function SetResult({componentsNumber, name, value}) {
    const [result, setResult] = useState(value ? value : [[]])
    const [rerender, setReRender] = useState(0)


    const buffer = []

    for(let i = 0; i < result.length; i++) {
        const components = []

        for(let j =0; j < componentsNumber; j++) {
            components.push((
                <Row key={`compoennt_row_${j}`}>
                    <Input
                        key={`input_${i}_${j}`}
                        onChange={(v) => {
                            let bufferResult= result
                            bufferResult[i][j] = v.target.value
                            setResult(bufferResult)
                            setReRender(Math.random())
                        }}
                        type='text'

                        value={result[i][j] || ''}
                    />
                    {(j != componentsNumber - 1) && (<WrapperKey>,</WrapperKey>) }
                </Row>
            ))
        }

        buffer.push(
            <WrapperSet key={`set_${i}`}>
                <Row> <WrapperKey>(</WrapperKey> {components}  <WrapperKey>) </WrapperKey>
                    {i > 0 && (
                        <RemoveButton onClick={() => {
                            setResult([...result.slice(0, i), ...result.slice(i + 1)])
                            setReRender(Math.random())
                        }}>
                            <img  width={10} src={'/images/icons/icon_remove.svg'} />
                        </RemoveButton>
                    )}

                    {(i < result.length - 1) ? (<WrapperKey>,</WrapperKey>) : null} </Row>
            </WrapperSet>
        )
    }

    return (
        <Wrapper>
            <WrapperKey>{'{'}</WrapperKey> {buffer}  <ButtonAdd onClick={(e) => {
                e.preventDefault();
                setResult([...result, []])}} >+</ButtonAdd> <WrapperKey>{'}'}</WrapperKey>

            <input type='hidden' name={name} value={JSON.stringify(result)} />

        </Wrapper>
    );
}

export default SetResult;


const RemoveButton = styled.div`
  position: absolute;
  cursor:pointer;
  margin-left: 174px;
  margin-top: -8px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
   flex-wrap: wrap;
`

const WrapperSet = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const WrapperKey = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 4px;
    padding-left: 4px;

`

const ButtonAdd = styled.button`
    border-radius: 4px;
    color: #FA9F63;
    padding-right: 8px;
    padding-left: 8px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #FA9F63;
    margin-left: 8px;

    &:hover {
      background-color: #FA9F63;
      color: white;

    }

`

const Row = styled.div`
  display: flex;
  flex-direction: row;
`


const Input = styled.input`
  padding: 4px;
  width: 30px;
  font-size: 16px;
  margin: 4px;
text-align: center;
`;


if (document.getElementsByTagName('set-result')) {
    const elements = document.getElementsByTagName('set-result')

    for(let element of elements) {
        ReactDOM.render(
            <SetResult
                name={element.attributes.name && element.attributes.name.value}
                componentsNumber={element.attributes.componentsNumber ? parseInt(element.attributes.componentsNumber.value) :  2} />, element);
    }

}
